import { getJamo } from 'pages/SignUp/getJamo';
import { DiagnosisPaginationSearchFilterProps } from 'models/Hospital/diagnosisListPageTypes';
import { calculateAge } from '../utils/calculateAge';
import { changeMobileForm } from '../utils/changeMobileForm';

const diagnosisPaginationSearchFilter: DiagnosisPaginationSearchFilterProps = (
    searchValue,
    setSortDirections,
    setSortField,
    selectedSearchFilter,
    initData,
    setPage,
    handlePageGroup,
    setFilterData,
    type
) => {
    const disassembledName = getJamo(searchValue);
    const filterByName = (data: { patientName: string }) => getJamo(data.patientName).includes(disassembledName);
    const filterByIdentityNumber = (data: { patientIdentityNumber: string }) => {
        const { birthDate } = calculateAge(data.patientIdentityNumber);
        return getJamo(birthDate).includes(disassembledName);
    };
    const filterByMobile = (data: { patientMobile: string }) => changeMobileForm(data.patientMobile).includes(disassembledName);
    const filterByDoctorName = (data: { doctorName: string }) => getJamo(data.doctorName).includes(disassembledName);
    const resetSorting = () => {
        setSortDirections((prev) => ({
            ...Object.keys(prev).reduce((acc, key) => ({ ...acc, [key]: false }), {}),
            diagnosisDateTime: true,
        }));
        setSortField('diagnosisDateTime');
    };

    let result;
    switch (selectedSearchFilter) {
        case 0:
            result =
                type === 'mindUpAdmin'
                    ? initData?.filter((data) => filterByName(data) || filterByIdentityNumber(data) || filterByMobile(data) || filterByDoctorName(data))
                    : initData
                          ?.filter((data) => filterByName(data) || filterByIdentityNumber(data) || filterByMobile(data) || filterByDoctorName(data))
                          .sort((a, b) => {
                              return b.diagnosisDateTime.localeCompare(a.diagnosisDateTime);
                          });
            resetSorting();
            break;
        case 1:
            result =
                type === 'mindUpAdmin'
                    ? initData?.filter(filterByName)
                    : initData?.filter(filterByName).sort((a, b) => {
                          return b.diagnosisDateTime.localeCompare(a.diagnosisDateTime);
                      });
            resetSorting();
            break;
        case 2:
            result =
                type === 'mindUpAdmin'
                    ? initData?.filter(filterByIdentityNumber)
                    : initData?.filter(filterByIdentityNumber).sort((a, b) => {
                          return b.diagnosisDateTime.localeCompare(a.diagnosisDateTime);
                      });
            resetSorting();
            break;
        case 3:
            result =
                type === 'mindUpAdmin'
                    ? initData?.filter(filterByMobile)
                    : initData?.filter(filterByMobile).sort((a, b) => {
                          return b.diagnosisDateTime.localeCompare(a.diagnosisDateTime);
                      });
            resetSorting();
            break;
        case 4:
            result =
                type === 'mindUpAdmin'
                    ? initData?.filter(filterByDoctorName)
                    : initData?.filter(filterByDoctorName).sort((a, b) => {
                          return b.diagnosisDateTime.localeCompare(a.diagnosisDateTime);
                      });
            resetSorting();
            break;
    }
    setPage(1);
    handlePageGroup(0);
    return setFilterData(result || []);
};

export default diagnosisPaginationSearchFilter;
